import React from "react";
import styles from "./Section8.module.scss";

export const Section8 = function () {
  return (
    <section id="testimonial-section" className={`${styles.container} cc--component-container`}>
      <section className={styles.content}>
        <span className={styles.testimonial}>
          “At MIT Sloan Executive Education, we are focused on bridging the energy, engagement, and idea flow of
          physical in-person teaching and learning into online experiences. We aim to positively modify individual and
          collective behaviors that participants will take back to their teams and propagate throughout their
          organizations.”
        </span>
        <span className={`${styles.source} title`}>
          — Paul McDonagh-Smith, Digital Capability Leader, MIT Sloan Executive Education
        </span>
      </section>
    </section>
  );
};
